import * as React from "react";
export const PasswordBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
